<template>
    <div class="pt-select-div" v-if="$attrs.mode == 'multiple'">
        <a-select  :allowClear="allowClear" :style="selectStyle" :filterOption="filterOption" showSearch @change="changeValue" v-model="input" v-bind="$attrs" v-on="$listeners" :placeholder=placeholder>
            <a-icon slot="suffixIcon" type="caret-down" />
            <a-select-option v-for="(item,inde) in users" :key="inde" v-if="!showQuit" :disabled="isDisabledUser(item.accountid)" :value="item.accountid"><span :class="item.active?'quiteClass':''">{{item.userName}}</span></a-select-option>
            <a-select-option v-for="(item,inde) in users" :key="inde" v-if="showQuit && item.active" :disabled="isDisabledUser(item.accountid)" :value="item.accountid"><span>{{item.userName}}</span></a-select-option>
        </a-select>
        <a-icon class="multiple-icon" :class="open?'openClass':''" type="caret-down"></a-icon>
    </div>
   <a-select v-else :allowClear="allowClear"  :filterOption="filterOption" showSearch @change="changeValue" v-model="input" v-bind="$attrs" v-on="$listeners" :placeholder=placeholder>
     <a-icon slot="suffixIcon" type="caret-down" />
     <a-select-option v-for="(item,inde) in users" :key="inde" :disabled="isDisabledUser(item.accountid)" :value="item.accountid"><span  :class="item.active?'quiteClass':''">{{item.userName}}</span></a-select-option>
   </a-select>
</template>

<script>
  /**
   * 包含离职人员
   */
  import UserApi from '@/api/sys/user'
  export default {
    name: 'ptUserSelectAll',
    props:{
      placeholder:{
        type:String,
      },
      allowClear:{
        type:Boolean,
        default:true,
      },
      value:{
        type: [Object, Array] | String,
      },
      disabledUsers:{
        type:Array,
        default:()=>{return []}
      },
      companyId:{
        type:String,
      },
      depId:{
        type:String,
      },
      showQuit:{
        type:Boolean,
        default:false,
      },
      selectStyle:{
        type:Object,
        default:()=>{
          return {width:'100%'}
        }
      },
    },
    data() {
      return {
        input:this.value,
        users:[],
        open:false,
      }
    },
    watch:{
      value (val) {
        this.input = val
        console.log("this.input",val)
      },
      input(val){
        this.$emit('input',val)
      },
      companyId(){
        this.initData()
      },
      depId(){
        this.initData()
      },
    },
    mounted(){
      this.initData()
    },
    methods:{
      dropdownVisibleChange(open){
        this.open = open
      },
      filterOption(input, option){
        return (
          option.componentOptions.children[0].children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        );
      },
      initData() {
        let queryVO ={}
        if(this.companyId){
          queryVO.companyId = this.companyId
        }
        if(this.depId){
          queryVO.depId = this.depId
        }
        UserApi.selectAllUsers(queryVO).then(res => {
          if (res.code == 1) {
            this.users = res.data
          }
        })
      },
      changeValue(value){
        this.$emit('input',value)
        this.$emit('change',value);
      },
      isDisabledUser(accountId) {
        return (this.disabledUsers || []).map(item => String(item)).indexOf(String(accountId)) !== -1
      }
    }
  }
</script>

<style scoped lang="less">
    .pt-select-div{
        position: relative;
        width: 100%;
        display: inline;
        /deep/ .ant-select-selection--multiple .ant-select-selection__placeholder{
            margin-left: 0px;
        }
        .multiple-icon{
            position: absolute;
            color: rgba(0, 0, 0, 0.25);
            right: 11px;
            top: 10px;
            font-size: 12px;
        }
        .openClass{
            transform: rotate(180deg);
        }
    }

    .quiteClass{
      color: #a1a1a1;
    }
</style>
